import { apiCall } from '../utils';
import { PROFILE_API } from '../constants';
import { ADMIN_EDITING_TYPE } from '../reducers/adminEditing.reducer';

import { userActions } from '.';
const { notification } = userActions;

export const adminEditingActions = {
  loadEditingProfile,
  clearEditingProfile,
};

// Nạp profile của ứng viên mà quản trị viên đang sửa hộ.
// KHÔNG chạm vào profileReducer.profile - xem chú thích ở adminEditing.reducer.
function loadEditingProfile(profileId) {
  return async (dispatch) => {
    dispatch({ type: ADMIN_EDITING_TYPE.LOADING });

    const api = PROFILE_API.getProfileById(profileId);
    const { response, error } = await apiCall({ ...api });

    if (!error && response.status === 200 && response.data.success) {
      dispatch({ type: ADMIN_EDITING_TYPE.SET_TARGET, payload: response.data.data });
      return response.data.data;
    }

    dispatch({ type: ADMIN_EDITING_TYPE.FAILURE, error });
    dispatch(notification({
      message: 'Không lấy được thông tin ứng viên cần sửa',
      type: 'error',
    }));
    return false;
  };
}

function clearEditingProfile() {
  return { type: ADMIN_EDITING_TYPE.CLEAR_TARGET };
}
